// Mock API responses for development and testing
const mockResponses = {
  // Auth endpoints
  '/auth/login': (data) => {
    const { email, password } = data;
    if (email && password) {
      return {
        success: true,
        token: 'mock-jwt-token',
        user: {
          id: '12345',
          name: 'Test User',
          email: email,
          userType: data.userType || 'candidate'
        }
      };
    } else {
      return {
        success: false,
        error: 'Invalid credentials'
      };
    }
  },

  '/auth/register': (data) => {
    const { email, password, userType } = data;
    if (email && password) {
      return {
        success: true,
        token: 'mock-jwt-token',
        user: {
          id: '12345',
          name: 'New User',
          email: email,
          userType: userType || 'candidate'
        }
      };
    } else {
      return {
        success: false,
        error: 'Invalid registration data'
      };
    }
  },

  '/auth/me': () => {
    return {
      success: true,
      user: {
        id: '12345',
        name: 'Test User',
        email: 'test@example.com',
        userType: 'candidate',
        profileCompleted: true
      }
    };
  },

  // General Dashboard endpoint - ADDED THIS ENDPOINT
  '/dashboard': (data, headers) => {
    // Check if the user is an employer based on Authorization header or other means
    const isEmployer = headers && headers.Authorization && headers.Authorization.includes('employer');
    
    if (isEmployer) {
      // Return employer dashboard data
      return {
        success: true,
        user: {
          name: 'Employer User',
          companyName: 'Tech Innovations Inc.',
          profilePicture: 'https://via.placeholder.com/150',
          industry: 'Technology',
          location: 'San Francisco, CA',
          profileCompleted: true
        },
        stats: {
          openPositions: 12,
          activeApplications: 87,
          candidatesInPipeline: 34
        },
        recentActivity: [
          {
            id: 'act1',
            type: 'application',
            description: 'New application received for Senior Developer position',
            timestamp: '2023-09-22T14:30:00Z'
          },
          {
            id: 'act2',
            type: 'interview',
            description: 'Interview scheduled with Sarah Martinez',
            timestamp: '2023-09-22T10:15:00Z'
          },
          {
            id: 'act3',
            type: 'job',
            description: 'New job posted: UX Designer',
            timestamp: '2023-09-21T16:45:00Z'
          }
        ],
        // upcomingInterviews removed
        topJobs: [
          {
            id: 'job1',
            title: 'Senior Full Stack Developer',
            applications: 24,
            views: 342,
            daysActive: 7
          },
          {
            id: 'job2',
            title: 'DevOps Engineer',
            applications: 18,
            views: 275,
            daysActive: 5
          },
          {
            id: 'job3',
            title: 'UX Designer',
            applications: 15,
            views: 210,
            daysActive: 3
          }
        ]
      };
    } else {
      // Return candidate dashboard data
      return {
        success: true,
        user: {
          name: 'John Doe',
          profilePicture: 'https://via.placeholder.com/150',
          title: 'Senior Frontend Developer',
          location: 'New York, NY',
          profileCompleteness: 85
        },
        stats: {
          activeApplications: 8,
          savedJobs: 15,
          newAlerts: 4
        },
        recommendedJobs: [
          {
            id: 1,
            title: 'Senior Frontend Developer',
            company: 'Tech Solutions Inc.',
            logo: 'https://via.placeholder.com/40',
            location: 'New York, NY',
            type: 'Full-time',
            salary: '$80,000 - $100,000',
            postedDate: '2 days ago',
            matchPercentage: 95
          }
        ]
      };
    }
  },

  // Employer Dashboard endpoints
  '/dashboard/stats': () => {
    return {
      success: true,
      stats: {
        activeJobs: 3,
        totalApplications: 12,
        newCandidates: 5
      }
    };
  },
  
  // Candidate Dashboard endpoints
  '/candidate/dashboard': () => {
    return {
      success: true,
      user: {
        name: 'John Doe',
        profilePicture: 'https://via.placeholder.com/150',
        title: 'Senior Frontend Developer',
        location: 'New York, NY',
        profileCompleteness: 85
      },
      stats: {
        activeApplications: 8,
        savedJobs: 15,
        newAlerts: 4
      },
      recommendedJobs: [
        {
          id: 1,
          title: 'Senior Frontend Developer',
          company: 'Tech Solutions Inc.',
          logo: 'https://via.placeholder.com/40',
          location: 'New York, NY',
          type: 'Full-time',
          salary: '$80,000 - $100,000',
          postedDate: '2 days ago',
          matchPercentage: 95
        },
        {
          id: 2,
          title: 'UX/UI Designer',
          company: 'Creative Studios',
          logo: 'https://via.placeholder.com/40',
          location: 'Remote',
          type: 'Contract',
          salary: '$70 - $90 per hour',
          postedDate: '1 week ago',
          matchPercentage: 88
        },
        {
          id: 3,
          title: 'Full Stack Developer',
          company: 'Startup Innovations',
          logo: 'https://via.placeholder.com/40',
          location: 'San Francisco, CA',
          type: 'Full-time',
          salary: '$110,000 - $130,000',
          postedDate: '3 days ago',
          matchPercentage: 82
        }
      ]
    };
  },
  
  // Jobs endpoint
  '/jobs': () => {
    return {
      success: true,
      jobs: [
      {
        id: 'job_001',
        title: 'Senior Frontend Developer',
        location: 'Remote',
        type: 'Full-time',
        salary: '$100,000 - $130,000',
        description: 'We are looking for a Senior Frontend Developer with expertise in React, TypeScript, and modern CSS frameworks.',
        requirements: [
          'Strong proficiency in JavaScript, including DOM manipulation',
          'Thorough understanding of React.js and its core principles',
          'Experience with popular React workflows (Redux, Hooks, etc)',
          'Familiarity with newer specifications of ECMAScript'
        ],
        responsibilities: [
          'Developing new user-facing features using React.js',
          'Building reusable components and front-end libraries',
          'Translating designs and wireframes into high-quality code',
          'Optimizing components for maximum performance'
        ],
        skills: ['React', 'JavaScript', 'TypeScript', 'CSS', 'HTML'],
        experience: '5+ years',
        education: 'Bachelor\'s degree in Computer Science or related field',
        postedBy: 'emp_dev_12345',
        recruiterId: null,
        status: 'Active',
        applicants: [],
        createdAt: '2023-09-26T14:30:00Z',
        updatedAt: '2023-09-26T14:30:00Z'
      },
      {
        id: 'job_002',
        title: 'UX Designer',
        company: 'Creative Design Studio',
        location: 'New York, NY',
        type: 'Full-time',
        salary: '$80,000 - $110,000',
        description: 'We are seeking a talented UX Designer to create amazing user experiences for our clients.',
        requirements: [
          'Proven experience as a UX Designer or similar role',
          'Strong portfolio of design projects',
          'Proficiency in design software (Figma, Sketch, Adobe XD)',
          'Understanding of interaction design principles'
        ],
        responsibilities: [
          'Gather and evaluate user requirements',
          'Create user flows, wireframes, and prototypes',
          'Conduct usability testing',
          'Collaborate with UI designers and development teams'
        ],
        skills: ['UI/UX', 'Figma', 'Sketch', 'User Research', 'Prototyping'],
        experience: '3+ years',
        education: 'Bachelor\'s degree in Design or related field',
        postedBy: 'emp_dev_12345',
        recruiterId: null,
        status: 'Active',
        applicants: [],
        createdAt: '2023-09-19T10:15:00Z',
        updatedAt: '2023-09-19T10:15:00Z'
      }
      ],
      pagination: {
        total: 2,
        limit: 10,
        page: 1,
        pages: 1
      }
    };
  },
  
  // Recruiters endpoint
  'recruiters': () => {
    return {
      success: true,
      recruiters: [
        {
          id: 'rec_001',
          name: 'Jane Smith',
          email: 'jane.smith@example.com',
          phone: '+1234567890',
          employerId: 'emp_dev_12345',
          status: 'active',
          invitedAt: '2023-09-03T14:30:00Z',
          joinedAt: '2023-09-04T10:15:00Z',
          performance: {
            jobsPosted: 5,
            candidatesHired: 2
          }
        },
        {
          id: 'rec_002',
          name: 'John Doe',
          email: 'john.doe@example.com',
          phone: '+1987654321',
          employerId: 'emp_dev_12345',
          status: 'active',
          invitedAt: '2023-09-18T09:45:00Z',
          joinedAt: '2023-09-19T14:30:00Z',
          performance: {
            jobsPosted: 3,
            candidatesHired: 1
          }
        }
      ],
      totalSeats: 5,
      availableSeats: 3,
      activeRecruiters: 2
    };
  },
  
  // Billing/subscription endpoint
  'billing/subscription': () => {
    return {
      success: true,
      currentPlan: {
        name: 'Premium Plan',
        price: 199.99,
        billingCycle: 'monthly',
        startDate: '2023-09-03T00:00:00Z',
        renewalDate: '2023-10-03T00:00:00Z',
        status: 'active',
        features: {
          'AI Credits': 100,
          'Recruiter Seats': 5,
          'Job Postings': 'Unlimited',
          'Advanced Analytics': true,
          'Priority Support': true
        }
      },
      invoices: [
        {
          id: 'INV-001',
          date: '2023-09-03T00:00:00Z',
          amount: 199.99,
          status: 'paid',
          description: 'Monthly Subscription - Premium Plan'
        },
        {
          id: 'INV-002',
          date: '2023-08-03T00:00:00Z',
          amount: 199.99,
          status: 'paid',
          description: 'Monthly Subscription - Premium Plan'
        }
      ]
    };
  }
};

// Mock API implementation
const mockApi = {
  get: (url) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const endpoint = Object.keys(mockResponses).find(key => url.includes(key));
        if (endpoint) {
          const response = mockResponses[endpoint]({}, { Authorization: 'Bearer employer-token' });
          resolve({ data: response });
        } else {
          reject({ response: { status: 404, data: { error: 'Not found' } } });
        }
      }, 500); // Simulate network delay
    });
  },
  
  post: (url, data) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const endpoint = Object.keys(mockResponses).find(key => url.includes(key));
        if (endpoint) {
          const response = mockResponses[endpoint](data);
          resolve({ data: response });
        } else {
          reject({ response: { status: 404, data: { error: 'Not found' } } });
        }
      }, 500); // Simulate network delay
    });
  },
  
  delete: (url) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        // Handle recruiter deletion
        if (url.includes('/api/recruiters/')) {
          // Extract recruiter ID from URL
          const recruiterId = url.split('/').pop();

          // Return success response
          resolve({
            data: {
              success: true,
              message: 'Recruiter removed successfully'
            }
          });
        } else {
          reject({ response: { status: 404, data: { error: 'Not found' } } });
        }
      }, 500); // Simulate network delay
    });
  }
};

export default mockApi;
